// extracted by mini-css-extract-plugin
export default {"input_block":"addKpiTask_input_block__PCyea","input_block_title":"addKpiTask_input_block_title__HE4RI","error":"addKpiTask_error__zbzX9","buttons":"addKpiTask_buttons__A4yNo"};